import React from "react";
import { Handle, Position } from "reactflow";

const EndNodeComponent: React.FC = () => {
    return (
        <div className="workflow-end-node" aria-label="End">
            <Handle type="target" position={Position.Top} className="workflow-end-node__handle" />
            <div className="workflow-end-node__line" />
            <div className="workflow-end-node__pill">End</div>
        </div>
    );
};

export const EndNode = React.memo(EndNodeComponent);
